import { render, staticRenderFns } from "./LiabilityGT.vue?vue&type=template&id=03dd443a&scoped=true&"
import script from "./LiabilityGT.vue?vue&type=script&lang=ts&"
export * from "./LiabilityGT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd443a",
  null
  
)

export default component.exports